import { Box, Divider, styled, Typography } from '@mui/material';
import { KPI_CARD_SIZES } from '../constants';
import { StatisticSize, Trend } from '../types';
import { getTrendColor } from '../utils';

const baseValueStyles = (size: StatisticSize) => {
  const sizeConfig = KPI_CARD_SIZES[size] ?? KPI_CARD_SIZES.md;

  return {
    fontSize: sizeConfig.valueFontSize,
    whiteSpace: 'nowrap',
    lineHeight: 1,
  };
};

export const ValueRowWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  gap: theme.spacing(0.5),
}));

export const ValueWrapper = styled(Typography, {
  shouldForwardProp: (prop) =>
    !['size', 'trend', 'error'].includes(prop as string),
})<{
  size?: StatisticSize;
  trend?: Trend;
  error?: boolean;
}>(({ theme, size = 'md', trend, error }) => ({
  ...baseValueStyles(size),
  color: getTrendColor(theme, trend, error),
}));

export const PrefixWrapper = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ size = 'md' }) => baseValueStyles(size));

export const SuffixWrapper = PrefixWrapper;

export const EmptyValueWrapper = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => ({
  ...baseValueStyles(size),
  color: theme.palette.text.disabled,
}));

export const ErrorValueWrapper = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => ({
  ...baseValueStyles(size),
  color: theme.palette.error.main,
}));

export const InfoIconWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const VerticalDivider = styled(Divider)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  marginRight: theme.spacing(0.5),
  borderRightWidth: 2,
}));
